import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import LoadArsenalViewer from 'Utils/LoadArsenalViewer'

const uidMap = [
  {
    uid: 'MARMC0013357',
    gltf: 'armchair.gltf',
    usdz: 'armchair.usdz',
    preview: 'armchair.png',
    name: 'Armchair 3D Model CGTrader',
  },
  {
    uid: 'MSOFA0013358',
    gltf: 'sofa3seat.gltf',
    usdz: 'sofa3seat.usdz',
    preview: 'sofa3seat.jpg',
    name: '3 Seat Sofa 3D Model CGTrader',
  },
  {
    uid: 'MSPHR0013359',
    gltf: 'sphere.gltf',
    usdz: 'white_sphere.usdz',
    preview: 'white_sphere.jpg',
    name: 'White Sphere 3D Model CGTrader',
  },
]

function ViewerContainer({ uid }) {
  useEffect(() => {
    const model = uidMap.find(item => item.uid === uid)
    if (model) {
      LoadArsenalViewer(model)
    }
  }, [])

  if (typeof window === 'undefined') return null

  return (
    <div className="arsenal-viewer header__viewer-container" />
  )
}

ViewerContainer.propTypes = {
  uid: PropTypes.string.isRequired,
}

export default ViewerContainer
